import "./App.css";
import Home from "./components/screens/Home";

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
